import {
  ActionArm,
  ActionDisarm,
  ActionElevate,
  ActionGoto,
  ActionQLand,
  ActionStickControl,
  ActionTakeoff,
  CameraGimbal,
  CameraLiveView,
  CameraShoot,
  CameraSetAutoShoot,
  MissionClear,
  MissionLoad,
  MissionResume,
  MissionStart,
  MissionUpload,
  ModeAuto,
  ModeFBWA,
  ModeLoiter,
  ModeQRTL,
  ModeRTL,
  ModeStabilize,
} from '@/define/commandSet/mavlink';

const operation = [
  {
    name: 'Mode',
    commands: [ModeAuto, ModeLoiter, ModeFBWA, ModeStabilize, ModeRTL, ModeQRTL],
  },
  {
    name: 'Action',
    commands: [ActionArm, ActionDisarm, ActionTakeoff, ActionGoto, ActionElevate, ActionStickControl, ActionQLand],
  },
  {
    name: 'Camera',
    commands: [CameraLiveView, CameraGimbal, CameraShoot, CameraSetAutoShoot],
  },
  {
    name: 'Mission',
    commands: [MissionLoad, MissionUpload, MissionStart, MissionResume, MissionClear],
  },
];

export default operation;
